
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class LegsBlockBtn extends Vue {
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  public handleClick() {
    this.$emit('click');
  }
}
